import { useCallback, useEffect, useState } from 'react'

import { oxford } from 'humanize-plus'

import { useToast } from '@driftt/dds'

import { trackEvent } from 'utils/tracking'

const useCopyEmailToClipboard = (
  incompleteSalesRepMetric,
  metricIdentifier
) => {
  const [isCopied, setIsCopied] = useState(false)
  const triggerToast = useToast()

  const handleCopyEmailToClipboard = useCallback(() => {
    const emails = incompleteSalesRepMetric.map((rep) => rep.email)
    const emailsToCopy = oxford(emails)

    navigator.clipboard
      .writeText(emailsToCopy)
      .then(() => {
        setIsCopied(true)
        triggerToast({
          message: 'Emails copied',
          variant: 'success',
        })
        trackEvent('SALES_REP_SETUP_COPY_EMAILS', {
          metricIdentifier: metricIdentifier,
          incompleteReps: emails.length,
        })
      })
      .catch(() => {
        triggerToast({
          message: 'Error copying emails',
          variant: 'error',
        })
      })
  }, [incompleteSalesRepMetric, metricIdentifier])

  useEffect(() => {
    if (isCopied) {
      const timeout = setTimeout(() => {
        setIsCopied(false)
      }, 4000)

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [isCopied])

  return { handleCopyEmailToClipboard, isCopied }
}

export default useCopyEmailToClipboard
